import { useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { redirectToAuthorize } from "../../utils/pkce";
import { API_BASE_URL, CLIENT_ID, REDIRECT_URI, loginConfig } from "../../auth/config";
import useBfcacheReload from "../../utils/useBfcacheReload";
import { getDefaultDashboardPath } from "../../utils/userRole";
import ktLogo from "../../assests/ktlogo.svg";
import styles from "./login.module.scss";

export default function Login() {
  useBfcacheReload();
  const location = useLocation();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [error, setError] = useState(location.state?.loginError || "");
  const accessToken = useSelector((state) => state.auth?.accessToken);
  const loginUser = useSelector((state) => state.auth?.loginUser);

  if (accessToken) {
    const destination = getDefaultDashboardPath(loginUser);
    return <Navigate to={destination} replace />;
  }

  const handleLogin = async () => {
    setError("");
    setIsRedirecting(true);
    try {
      await redirectToAuthorize({
        apiBaseUrl: API_BASE_URL,
        clientId: CLIENT_ID,
        redirectUri: REDIRECT_URI,
      });
    } catch (err) {
      console.error("Failed to start login:", err);
      setError("Something went wrong while starting login. Please try again.");
      setIsRedirecting(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <img src={ktLogo} alt="Kriha Teams" className={styles.logo} />
        <h1 className={styles.title}>Welcome back</h1>
        <p className={styles.subtitle}>Sign in to access your admin dashboard</p>

        <button
          type="button"
          className={styles.loginButton}
          onClick={handleLogin}
          disabled={isRedirecting}
        >
          {isRedirecting ? "Redirecting..." : "Login with Auth"}
        </button>

        {error && <div className={styles.error}>{error}</div>}

        <div className={styles.footer}>Secured by Kriha SSO</div>

        {loginConfig.methods.length > 1 && (
          <Link to="/" className={styles.footer}>
            ← Other ways to sign in
          </Link>
        )}
      </div>
    </div>
  );
}
